import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "home",
		component: () => import("@/views/Home.vue"),
	},
	{
		path: "/home",
		name: "home",
		component: () => import("@/views/Home.vue"),
	},
	{
		path: "*",
		name: "404",
		component: () => import("@/views/404.vue"),
		meta: {
			open: true,
			full: true,
		},
	},
	{
		path: "/login",
		name: "登录",
		component: () => import("@/views/Login.vue"),
		meta: {
			open: true,
			full: true,
		},
	},
	{
		path: "/overhaul/overhaulList",
		name: "维修管理-维修列表",
		component: () => import("@/views/overhaul/overhaulList.vue"),
	},
	{
		path: "/overhaul/overhaulDetail",
		name: "维修管理-维修详情",
		component: () => import("@/views/overhaul/overhaulDetail.vue"),
	},
	{
		path: "/claimManagement/claimList",
		name: "理赔管理",
		component: () => import("@/views/claimManagement/claimList.vue"),
	},
	{
		path: "/claimManagement/claimDetail",
		name: "理赔详情",
		component: () => import("@/views/claimManagement/claimDetail.vue"),
	},
];

const router = new VueRouter({
	mode: "hash",
	base: process.env.BASE_URL,
	routes: routes,
});

export default router;
